import { Autocomplete, TextField } from "@mui/material"

const getSelectedUserOption = (users, person) => {
    if (!person) return null

    const personId = person?._id || person
    return users.find((user) => user.value === personId) || (
        person?._id
            ? { value: person._id, label: `${person.firstName || ""} ${person.lastName || ""}`.trim() }
            : null
    )
}

const SaleInfo = ({ quote, patchQuote, flushQuotePatch, users = [], readOnly = false }) => {
    return (
        <div className="hive-quote-sale-info" style={{display: "flex", flexWrap: "wrap", justifyContent: "space-evenly"}}>
            <div className="col-12 col-sm-5" style={{margin: "0.5em"}}>
                <TextField fullWidth label="Doc Date" value={quote?.quoteDate?.split("T")[0] || ""} disabled />
            </div>

            <div className="col-12 col-sm-5" style={{margin: "0.5em"}}>
                <TextField fullWidth label="Doc ID" value={quote?._id || ""} disabled />
            </div>

            <div className="col-12 col-sm-5" style={{margin: "0.5em"}}>
                <TextField fullWidth label="Project Number" onChange={(e) => patchQuote({ projectNumber: e.target.value })} onBlur={flushQuotePatch} value={quote?.projectNumber || ""} disabled={readOnly} />
            </div>

            <div className="col-12 col-sm-5" style={{margin: "0.5em"}}>
                <TextField fullWidth label="FOB" onChange={(e) => patchQuote({ fob: e.target.value })} onBlur={flushQuotePatch} value={quote?.fob || ""} disabled={readOnly} />
            </div>

            <div className="col-12 col-sm-5" style={{margin: "0.5em"}}>
                <Autocomplete
                    options={users}
                    value={getSelectedUserOption(users, quote?.salesManager)}
                    getOptionLabel={(option) => option.label}
                    isOptionEqualToValue={(option, value) => option.value === value.value}
                    onChange={(e, newValue) => {
                        patchQuote({ salesManager: newValue ? newValue.value : null });
                    }}
                    disabled={readOnly}
                    renderInput={(params) => <TextField {...params} label="Sales Manager" />}
                />
            </div>

            <div className="col-12 col-sm-5" style={{margin: "0.5em"}}>
                <TextField fullWidth label="Terms" onChange={(e) => patchQuote({ terms: e.target.value })} onBlur={flushQuotePatch} value={quote?.terms || ""} disabled={readOnly} />
            </div>
        </div>
    )
}

export default SaleInfo
